<template>
  <div class="">
    <div class="flex items-center">
      <div class="flex items-center">
        <input
          :id="uId"
          :type="type"
          :name="name"
          :checked="!!checked"
          :disabled="disabled"
          :value="checkedValue"
          :aria-label="name"
          class="accent-primary rounded text-primary transition-all duration-100 ease-out"
          :class="[
            {
              'input-error': errorMessage,
            },

            size ? 'h-7 w-7 md:h-10 md:w-10' : 'h-6 w-6',
          ]"
          @input="handleChange"
        />
        <label :for="uId"></label>
      </div>
      <label
        :for="uId"
        class="ml-4 text-secondary font-medium flex items-center gap-2 flex-1"
        :class="[
          { 'text-black': errorMessage },
          { 'text-sm font-medium md:text-2xl': size },
        ]"
      >
        <slot name="label" :u-id="uId">{{ $t(label) }}</slot>
        <span v-if="required" class="text-danger dark:text-danger">*</span>
      </label>
    </div>
    <div v-if="single" class="pl-10">
      <span
        v-show="errorMessage"
        class="text-xs font-medium text-danger dark:text-danger"
      >
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script setup>
  import { useField } from 'vee-validate';
  import { computed } from 'vue';
  import uniqueId from 'lodash/uniqueId.js';

  defineEmits([
    'keydown',
    'blur',
    'change',
    'input',
    'focus',
    'update:modelValue',
  ]);
  const props = defineProps({
    label: String,
    text: String,
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'radio',
    },
    size: {
      type: Boolean,
      default: false,
    },
    id: String,
    placeholder: String,
    component: {
      type: String,
      default: null,
    },
    modelValue: [Boolean, String, Number],
    btn: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    single: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    checkedValue: {
      type: [Boolean, String, Number],
      default: '1',
    },
    uncheckedValue: {
      type: [Boolean, String, Number],
      default: '',
    },
  });

  // const setSingleError = inject('setSingleError')

  const uId = computed(() => props.id || uniqueId('input'));

  const { errorMessage, handleChange, checked } = useField(
    () => props.name,
    undefined,
    {
      initialValue: props.modelValue,
      type: 'radio',
      checkedValue: props.checkedValue,
      uncheckedValue: props.uncheckedValue,
    },
  );
  // setValue(uncheckedValue.value)
  // watch(errorMessage, (v) => {
  //     if (setSingleError) {
  //         setSingleError(v)
  //     }
  // })
  // handleChange(props.value);
</script>

<style scoped>
  .form-checkbox {
    box-shadow: unset !important;
  }
</style>
